export function getQuery(parameters?: Record<string, unknown>) {
  if (!parameters) return null;
  switch (parameters.type) {
    case "checkbox":
    case "multi-checkbox": {
      const valueObject = parameters.value as Record<string, boolean>;
      return Object.keys(valueObject)
        .filter((key) => valueObject[key])
        .join(",");
    }
    case "radio": {
      return parameters.value ? String(parameters.value) : null;
    }
    case "visa": {
      if (typeof parameters.value === "boolean") {
        return parameters.value ? "none" : "";
      }
      if (parameters.value) {
        const valueObject = parameters.value as Record<string, boolean>;
        return Object.keys(valueObject)
          .filter((key) => valueObject[key])
          .join(",");
      }
      return String(parameters.value);
    }
    case "counter":
    case "range": {
      return parameters.value ? String(parameters.value) : null;
    }
    case "time-range": {
      return parameters.value ? String(parameters.value) : null;
    }
    case "input": {
      return parameters.value ? String(parameters.value) : null;
    }
    case "switch": {
      return parameters.value ? "true" : null;
    }
    default: {
      return null;
    }
  }
}
